module.exports = __webpack_public_path__ + "img/openMark01.a23b40c4.png";